export const graphicTools = [
    {
      name: "Adobe Illustrator",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Adobe_Illustrator_CC_icon.svg").default}
        ></img>
      ),
      rate: "90%",
    },
    {
      name: "Adobe InDesign",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Adobe_InDesign_CC_icon.svg").default}
        ></img>
      ),
      rate: "90%",
    },
    {
      name: "Adobe Photoshop",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Adobe_Photoshop_CC_icon.svg").default}
        ></img>
      ),
      rate: "90%",
    },
    {
      name: "Adobe After Effects",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Adobe_After_Effects_CC_icon.svg").default}
        ></img>
      ),
      rate: "75%",
    },
    {
      name: "Powerpoint",
      icon: "",
      rate: "90%",
    },
    {
      name: "Procreate",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Procreate-icon.png")}
        ></img>
      ),
      rate: "90%",
    },
    {
      name: "Sketch",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Sketch_Logo.svg").default}
        ></img>
      ),
      rate: "75%",
    },
    {
      name: "Figma",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon1"
          src={require("../assets/Sketch_Logo.svg").default}
        ></img>
      ),
      rate: "50%",
    },
    {
      name: "Wordpress",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon2"
          src={require("../assets/Wordpress-Logo.svg").default}
        ></img>
      ),
      rate: "50%",
    },
    {
      name: "Elementor",
      icon: (
        <img
          alt="tool-icon-img"
          className="AboutMeSkillsAndTools-toolIcon2"
          src={require("../assets/Elementor-Logo-Symbol-Red.svg").default}
        ></img>
      ),
      rate: "75%",
    },
    {
      name: "Blender",
      icon: "",
      rate: "45%",
    },
  ];